export const CONTEST_WINDOW_DURATION_OPTIONS = [
  {
    label: '90 Mins',
    value: 90,
  },
  {
    label: '120 Mins',
    value: 120,
  },
  {
    label: '180 Mins',
    value: 180,
  },
  {
    label: '2 Days',
    value: 2880,
  },
  {
    label: '7 Days',
    value: 10080,
  },
  {
    label: '45 Days',
    value: 64800,
  },
];
